import type { DiscountType, ItemType } from "@shared/graphql.types"
import { calcDiscountPrice } from "../components/Basket/utils/calcDiscountPrice"
import { getDiscountEffectsByTargetType } from "../components/Basket/utils/getDiscountEffectsByTargetType"

export const getDiscountedItemPrice = (
  item: ItemType,
  itemPrice: number,
  userDiscounts: Array<DiscountType> = []
): number => {
  const itemPriceEffects = getDiscountEffectsByTargetType(
    "item_price",
    userDiscounts
  )

  if (!itemPriceEffects.length) return itemPrice

  // Just return the first one as we get one per item quantity. We handle the quantity in the calcPrice function
  const itemEffect = itemPriceEffects.find((effect) => {
    if (item.type === "membership" || item.type === "giftMembership") {
      return effect?.targetPimId === item?.membership?.id
    }

    return effect?.targetPimId === item?.variant?.id
  })

  if (!itemEffect) return itemPrice
  return calcDiscountPrice([itemEffect], itemPrice)
}
